<template>
  <div class="checkbox">
    <label :for="'option-' + optionName">
      <div v-if="value" class="checkbox_label _active">
        <DoneIcon />
      </div>
      <div v-else class="checkbox_label" />
      <slot name="default">
        <span>{{ label }}</span>
      </slot>
      <slot name="label"></slot>
    </label>
    <input
      type="checkbox"
      :id="'option-' + optionName"
      v-model="selectedOptions"
      :value="value"
      @change="changeOption($event)"
    />
  </div>
</template>

<script>
import DoneIcon from "@/components/icons/DoneIcon.vue";

export default {
  name: "Checkbox",
  components: { DoneIcon },

  emits: ["update:value"],

  props: {
    value: {
      type: Boolean,
      required: true,
    },

    label: {
      type: String,
      default: "",
    },

    optionName: {
      type: String,
      default: "",
    },

    href: {
      type: String,
      default: "",
    },
  },

  data() {
    return {
      selectedOptions: false,
    };
  },

  mounted() {
    this.selectedOptions = this.value;
  },

  watch: {
    value(value) {
      this.selectedOptions = !!value;
    },
  },

  methods: {
    changeOption() {
      this.$emit("update:value", this.selectedOptions);
    },
  },
};
</script>

<style lang="scss" scoped>
.checkbox {
  display: inline-block;
  width: 100%;
  padding: 9px 7px 9px 12px;
  transition: color 0.3s ease;
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
  color: #222222;

  label {
    display: flex;
    align-items: center;

    span,
    a {
      word-break: normal;
      cursor: pointer;
    }
  }

  input {
    display: none;
  }

  &_label {
    flex: 0 0 auto;
    width: 16px;
    height: 16px;
    margin-right: 8px;
    border: 1px solid #858585;
    border-radius: 4px;

    &._active {
      display: flex;
      justify-content: center;
      align-items: center;
      border: 1px solid #f18e35;
    }
  }
}
</style>
